import { commonControllerUploadImages, commonControllerRequestShortUrlV2, type FileUploadRequestBodyCategory } from "@everon-it/api-client/contents-gw";
import { type Page, type UploadData } from "./types";

/** 이미지 업로드 */
export const requestImageUpload = async (uploadData: UploadData) => {
    const response = await commonControllerUploadImages({
        image: [uploadData.imageFile],
        category: uploadData.category as FileUploadRequestBodyCategory,
    });
    return response.rows[0];
};

/** 딥링크 생성 */
export const deepLink = async (page: Page, id: string) => {
    const deepLinkHost = process.env.REACT_APP_DEEP_LINK_HOST;
    let path = "";

    switch (page) {
        case "notice":
            path = `${deepLinkHost}/NoticeDetail?pageId=${id}`;
            break;
        case "event":
            path = `${deepLinkHost}/EventDetail?pageId=${id}`;
            break;
        case "faq":
            path = `${deepLinkHost}/FAQ?pageId=${id}`;
            break;
        case "chargerresolution":
            path = `${deepLinkHost}/ChargerResolutionDetail?pageId=${id}`;
            break;
        case "serviceintroduction":
            path = `${deepLinkHost}/ServiceIntroductionDetail?pageId=${id}`;
            break;

        default:
            return "";
    }

    const response = await commonControllerRequestShortUrlV2({ longUrl: path });
    return response.row.shortUrl;
};
